// Mute pointer events on descendants; re-enable on nested interactive elements and lift them above the parent hit area.
export const NESTED_INTERACTIVE_CLASSES =
    '**:pointer-events-none ' +
    '[&_a]:pointer-events-auto [&_a]:relative ' +
    '[&_button]:pointer-events-auto [&_button]:relative ' +
    '[&_[role="button"]]:pointer-events-auto [&_[role="button"]]:relative ' +
    '[&_[tabindex]:not([tabindex="-1"])]:pointer-events-auto ' +
    '[&_[tabindex]:not([tabindex="-1"])]:relative'
